import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

export interface GetUserAffiliatesParams {
  affiliateId: string;
}

export interface GetUserAffiliatesResponse {
  perDayClicks: number;
  perMonthClicks: number;
  perDaySales: number;
  perMonthSales: number;
  totalClicks: number;
  totalSales: number;
  perDayEarnings: number;
  perMonthEarnings: number;
  totalEarnings: number;
  perDayClickPaidCount: number;
  perMonthClickPaidCount: number;
  totalClickPaidCount: number;
  perDaySalesPaidCount: number;
  perMonthSalesPaidCount: number;
  totalSalesPaidCount: number;
}

const getUserAffiliatesData = async (
  params: GetUserAffiliatesParams
): Promise<GetUserAffiliatesResponse> => {
  const res = await axiosInstance.get(`/api/affiliates/${params.affiliateId}`);
  return res.data;
};

export const useGetUserAffiliatesData = () => {
  return useMutation(getUserAffiliatesData);
};
